// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox_wrapper__339Dt","errored":"checkbox_errored__O1RyN","checkMark":"checkbox_checkMark__bImss","error":"checkbox_error__Z_x_I","input":"checkbox_input__vkuA3"};